var canvas;

module.exports = function (svg) {
  canvas = INKIVE.Tool.getInstance().editor.canvas;
  processTextNodes($(svg).find('.textarea'));
  return svg;
};

function processTextNodes ($elems) {
  $elems.each(function () {
    $(this).addClass('subelement');
    if (!$(this).attr('id')) {
      $(this).attr('id', canvas.getNextId());
    }
  });
}
